import { Component, Inject, OnInit } from '@angular/core';
import { AbstractModal } from '../abstract-modal/abstract-modal';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateService } from '@aiwyn/shared';

@Component({
  selector: 'app-generic-error',
  templateUrl: './generic-error.component.html',
  styleUrls: ['./generic-error.component.scss'],
  standalone: false,
})
export class GenericErrorComponent extends AbstractModal implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<GenericErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string }) {
    super(dialogRef);
  }

  ngOnInit(): void {
  }
  /**
   * Close the modal.
   */
  onClose(): void {
    this.dialogRef.close();
  }

  getEmail(): string {
    const subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    return 'mailto:support@aiwyn.ai?subject=Error%20encountered&body=%0D%0A-----------------------------------------%0D%0APlace message above this line %0D%0AClient: ' + subdomain + ' %0D%0ATime: ' + DateService.getIsoDateTime();
  }
}
